<template>
  <div>
    <el-card>
      <div style="display: flex">
        <div style="width: 50%">
          <el-row>
            <el-col v-if="isShow">
              <el-button :disabled="editFlag" size="small" type="warning" @click="stprEdit">编辑</el-button>
            </el-col>
            <el-col v-else>
              <el-button size="small" type="primary" @click="submit()">保存</el-button>
              <el-button size="small" @click="closeEdit">取消</el-button>
            </el-col>
          </el-row>
          <el-form ref="emcdRef" :disabled="isShow" :model="emcdForm" :rules="emcdRules" label-width="100px">
            <el-row>
              <el-col :md="12">
                <el-form-item label="贴布片数：" prop="rfid_patch_num">
                  <el-input
                    v-model="emcdForm.rfid_patch_num"
                    maxlength="9"
                    show-word-limit
                    size="small"
                    @input="emcdForm.rfid_patch_num = keepNum99(emcdForm.rfid_patch_num)"
                  >
                    <template slot="append">片</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="绣片数量：" prop="rfid_emcd_num">
                  <el-input
                    v-model="emcdForm.rfid_emcd_num"
                    maxlength="9"
                    show-word-limit
                    size="small"
                    @input="emcdForm.rfid_emcd_num = keepNum99(emcdForm.rfid_emcd_num)"
                  >
                    <template slot="append">片</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :md="12">
                <el-form-item label="制卡针数：" prop="rfid_emcd_phr">
                  <el-input
                    v-model="emcdForm.rfid_emcd_phr"
                    maxlength="9"
                    show-word-limit
                    size="small"
                    @input="emcdForm.rfid_emcd_phr = helper.keepTNum(emcdForm.rfid_emcd_phr)"
                  >
                    <template slot="append">针</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="制卡个数：" prop="rfid_emcd_numb">
                  <el-input
                    v-model="emcdForm.rfid_emcd_numb"
                    maxlength="9"
                    show-word-limit
                    size="small"
                    @input="emcdForm.rfid_emcd_numb = helper.keepTNum(emcdForm.rfid_emcd_numb)"
                  >
                    <template slot="append">个</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="填卡人：" prop="card_user_id">
                  <el-select v-model="emcdForm.card_user_id" filterable placeholder="请选择">
                    <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form :disabled="isShow" label="right" label-width="100px">
            <el-row>
              <el-form-item label="制作人：" size="small">
                <el-select
                  v-model="emcdForm.stff_id"
                  :disabled="!['徐礼明', '盖新', 'Admin'].includes($cookies.get('userInfo').stff_name)"
                  filterable
                  placeholder="请选择"
                  @change="
                    val => {
                      const find = processList.find(item => item.value === val).o;
                      emcdForm.user_id = find.user_id;
                      emcdForm.stff_name = find.stff_name;
                    }
                  "
                >
                  <el-option v-for="item in processList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="岗位：" size="small">
                <el-input :value="emcdProp.user_jobs" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="难度系数：" size="small">
                <el-input :value="emcdProp.price" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item>
                <SubTable2 ref="subTable" :isShow="isShow" :stffList="processList" />
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { post } from '@api/request';
import { spocAPI } from '@api/modules/spoc';
import helper from '@assets/js/helper';
import SubTable2 from '@/views/DevelopManagement/SmplManage/TabChild/Componet/TabPanel/subTable/subTable2';

export default {
  components: { SubTable2 },
  data() {
    return {
      emcdForm: {
        rfid_emcd_id: '',
        rfid_id: '',
        card_user_id: null,
        stff_id: '',
        stff_name: '',
        user_id: '',
        user_rfid_no: '',
        rfid_patch_num: '',
        rfid_emcd_phr: '',
        rfid_emcd_num: '',
        rfid_emcd_numb: ''
      },
      isShow: true,
      emcdRules: {
        rfid_emcd_phr: [
          { required: true, message: '请填写制卡针数：', trigger: true },
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' }
        ],
        rfid_patch_num: [
          { required: true, message: '请填写贴补片数：', trigger: true },
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' }
        ],

        rfid_emcd_num: [
          { required: true, message: '请填写绣片数量：', trigger: true },
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' }
        ],
        rfid_emcd_numb: [{ pattern: /^[0-9]*$/, message: '只能输入零和正整数!' }]
      },
      originalEmcd: {
        rfid_emcd_phr: '',
        rfid_patch_num: '',
        rfid_emcd_num: '',
        rfid_emcd_numb: ''
      }
    };
  },
  props: {
    emcdProp: Object,
    rfid_perm_status: Number,
    rfid_Info: Object,
    editFlag: Boolean,
    mainIsShow: Boolean,
    stffList: Array,
    processList: Array
  },
  methods: {
    stprEdit() {
      this.$emit('num');
      this.isShow = false;
    },
    submit() {
      this.$refs['emcdRef'].validate(valid => {
        if (valid) {
          this.$confirm('此操作将保存修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(res => {
              if (!this.emcdForm.rfid_id) {
                this.emcdForm.rfid_id = this.rfid_Info.rfid_id;
              }
              this.emcdForm.list = this.$refs.subTable.tableData.filter(x => (x.rfid_emcd_id ? true : !x.rfid_emcd_id && !x.destroy_flag));
              post(spocAPI.edit_emcd, this.emcdForm)
                .then(res => {
                  if (res.data.code == 0) {
                    this.$message.success(res.data.msg);
                    this.originalEmcd.rfid_patch_num = this.emcdForm.rfid_patch_num;
                    this.originalEmcd.rfid_emcd_num = this.emcdForm.rfid_emcd_num;
                    this.originalEmcd.rfid_emcd_phr = this.emcdForm.rfid_emcd_phr;
                    this.originalEmcd.rfid_emcd_numb = this.emcdForm.rfid_emcd_numb;
                  } else {
                    this.$message.error(res.data.msg);
                  }
                  this.$emit('del');
                })
                .catch(res => {
                  this.$message.error(res.data.msg);
                });

              this.isShow = true;
            })
            .catch(res => {});
        }
      });
    },
    closeEdit() {
      this.$confirm('此操作将取消修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          this.isShow = true;
          this.$message.info('已取消修改');
          this.$emit('del');
          this.emcdForm.rfid_patch_num = this.originalEmcd.rfid_patch_num;
          this.emcdForm.rfid_emcd_num = this.originalEmcd.rfid_emcd_num;
          this.emcdForm.rfid_emcd_phr = this.originalEmcd.rfid_emcd_phr;
          this.emcdForm.rfid_emcd_numb = this.originalEmcd.rfid_emcd_numb;
        })
        .catch(res => {});
    },
    keepNum99(val) {
      let keepTNum = Number(helper.keepTNum(val));
      if (keepTNum > 99) {
        this.$message.warning('输入范围0～99超出最大限度');
        return 99;
      } else {
        return keepTNum;
      }
    }
  },
  watch: {
    emcdProp(res, oldValue) {
      this.emcdForm.rfid_emcd_id = res.rfid_emcd_id;
      this.emcdForm.rfid_emcd_phr = res.rfid_emcd_phr;
      this.emcdForm.rfid_id = res.rfid_id;
      this.emcdForm.rfid_patch_num = res.rfid_patch_num;
      this.emcdForm.card_user_id = res.card_user_id;
      this.emcdForm.stff_id = res.stff_id;
      this.emcdForm.stff_name = res.stff_name;
      this.emcdForm.user_id = res.user_id;
      this.emcdForm.user_rfid_no = res.user_rfid_no;
      this.emcdForm.rfid_emcd_num = res.rfid_emcd_num;
      this.emcdForm.rfid_emcd_numb = res.rfid_emcd_numb;

      this.originalEmcd.rfid_patch_num = res.rfid_patch_num;
      this.originalEmcd.rfid_emcd_num = res.rfid_emcd_num;
      this.originalEmcd.rfid_emcd_phr = res.rfid_emcd_phr;
      this.originalEmcd.rfid_emcd_numb = res.rfid_emcd_numb;
    },
    'emcdProp.list'(newValue, oldValue) {
      this.$refs.subTable.tableData = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>
